import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  processingBulkLabelsTitle: {
    description: 'bulk process attempting to validate labels title',
    defaultMessage: 'Processing Labels',
    id: '5y6h0M',
  },
  processingBulkLabelsContent: {
    description: 'bulk process attempting to validate labels content',
    defaultMessage: 'Processing {count, plural, one {label.} other {labels.}}',
    id: 'R9R3Dd',
  },
  purchasingBulkLabelsTitle: {
    description: 'bulk purchase attempting to buy labels title',
    defaultMessage: 'Purchasing Labels',
    id: 'VlUEOF',
  },
  purchasingBulkLabelsContent: {
    description: 'bulk purchase attempting to buy labels content',
    defaultMessage: 'Purchasing {count, plural, one {label.} other {labels.}}',
    id: '5vpWet',
  },
  purchasingBulkLabelsSuccessTitle: {
    description: 'bulk purchase complete title',
    defaultMessage: 'Purchasing Labels Success',
    id: 'cksxfn',
  },
  purchasingBulkLabelsSuccessContent: {
    description: 'bulk purchase complete success content',
    defaultMessage: 'You successfully purchased {count, plural, one {# label.} other {# labels.}}',
    id: 'gkP2eC',
  },
  purchasingBulkLabelsSuccessWithWarningsContent: {
    description: 'bulk purchase complete success with warnings content',
    defaultMessage:
      'You successfully purchased {successCount, plural, one {# label.} other {# labels.}} {warningCount, plural, one {# label} other {# labels}} had warnings. Please check your Label Queue for details',
    id: 'n8ZvRN',
  },
  purchasingHadSomeErrorsTitle: {
    description: 'bulk purchase mixed success title',
    defaultMessage: 'Purchasing Your Labels Partially Succeeded',
    id: 'M39Vhe',
  },
  purchasingBulkLabelsMixedContent: {
    description: 'bulk purchase mixed success content',
    defaultMessage:
      'Successfully purchased {successCount, plural, one {# label} other {# labels}}. There was an error with purchasing {errorCount, plural, one {# label} other {# labels}}, please check your Label Queue for more details.',
    id: 'KV8FDR',
  },
  errorBulkPurchaseTitle: {
    description: 'bulk purchase error purchasing some labels title',
    defaultMessage: 'Error Purchasing Labels',
    id: 'QXJapC',
  },
  errorBulkPurchaseContent: {
    description: 'bulk purchase error purchasing some labels title',
    defaultMessage:
      'There was an error purchasing {count, plural, one {# label} other {# labels}}. Check your Label Queue to resolve {count, plural, one {this issue} other {these issues}}.',
    id: 'e68ucC',
  },
  applyRecommendationsErrorTitle: {
    defaultMessage: 'Failed to apply savings',
    description: 'Notification title for when applying recommendations fails',
    id: '+qw3ge',
  },
  applyRecommendationsErrorContent: {
    defaultMessage: 'Please try again',
    description: 'Notification content for when applying recommendations fails',
    id: 'FYevOA',
  },
});
